import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/sellers/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/customers/$id', params: { id: params.id } });
  },
});
